import PromosContainer from "./PromosContainer";

export default PromosContainer;
